import { Component, Input, OnInit } from '@angular/core';
import { Aviso } from 'src/app/model/Aviso';
import { DocumentoPac } from 'src/app/model/DocumentoPac';
import { PacService } from 'src/app/services/pac.service';

@Component({
  selector: 'app-informacoes-de-cancelamento-do-saldo',
  templateUrl: './informacoes-de-cancelamento-do-saldo.component.html',
  styleUrls: ['./informacoes-de-cancelamento-do-saldo.component.scss'],
  standalone: false
})
export class InformacoesDeCancelamentoDoSaldoComponent implements OnInit {
  
  @Input() documentoPac: DocumentoPac = new DocumentoPac();
  
  ID_CANCELAMENTO: number = 9
  aviso: Aviso

  constructor(private pacService: PacService) { }

  ngOnInit(): void {
    this.pacService.buscarAvisoCancelamentoSaldo(this.documentoPac.id, this.ID_CANCELAMENTO).subscribe({
      next: (response: Aviso) => {
        this.aviso = response
      }
    })
  }
  
  
}
